import { useOutletContext } from "react-router-dom";
import StudentSidebar from "./studentSidebar";

type Ctx = { student: any | null };

const StudentDetailsTab = () => {
  const { student } = useOutletContext<Ctx>();

  if (!student) return null;

  return (
    <div className="row">
      <div className="col-md-12">
        <StudentSidebar student={student} />
      </div>
    </div>
  );
};

export default StudentDetailsTab;
